import { render, staticRenderFns } from "./XvOrderEdit.vue?vue&type=template&id=7c3a84a7&"
import script from "./XvOrderEdit.vue?vue&type=script&lang=ts&"
export * from "./XvOrderEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports